/**
 * Global values ​​in the application and their associated data types
 */
window.showControl = undefined; // (isShow, newScale, newRotate) => {};
window.restoreDecals = undefined; // {};
window.backEnd = undefined; // "http://localhost:81";
window.gotoTab = undefined; // () => {};
window.updateTheLogoText = undefined; // () => {};
window.textFontChanged = undefined; // () => {};
window.selectTextDecals = undefined; // () => {};
window.renderTextOnly = undefined; // () => {};
window.renderTextImage = undefined; // () => {};
window.textId = undefined;
window.currentAppliedStyleId = undefined;
window.currentStyle = undefined; // {};
window.currentLogo = undefined; // {};
window.currentPattern = undefined; // {};
window.styleScale = undefined; // () => {};
window.styleList = undefined; // [];
window.drawText = undefined; // () => {};
window.setUndoState = undefined; // () => {};
window.setRedoState = undefined; // () => {};
window.setClearState = undefined; // () => {};
window.decals = []; // []
window.isSelectedLogoTool = false;
window.isLoading = true;
window.isShareYourDesign = false;
window.isSelectingStyle = undefined; // ECM-547
window.texts = []; // []
window.deselectText = undefined; // () => {};
window.activeTextIdRef = '';
window.updateTextUIState = undefined; // () => {};
window.clearTextUIState = undefined; // () => {};
